import { createSelector } from '@reduxjs/toolkit';

import { CompPropertyDataState, SubjectPropertyDataState } from '../../../types.ts';
import { selectPropertyDataEntities } from './propertyDataSelectors.ts';

export const selectEditablePropertyDataEntities = createSelector(
  [selectPropertyDataEntities],
  (propertyDataEntities) =>
    Object.fromEntries(
      Object.entries(propertyDataEntities).map(([id, propertyDataEntity]) => {
        const propertyData =
          id === 'subject'
            ? (propertyDataEntity as SubjectPropertyDataState).subjectData
            : (propertyDataEntity as CompPropertyDataState).compData;

        return [id, { id, ...propertyData.editableData }];
      }),
    ),
);

export const selectEditablePropertyDataById = createSelector(
  [selectEditablePropertyDataEntities, (_state, id: string) => id],
  (editablePropertyDataEntities, id) => editablePropertyDataEntities[id],
);

export const selectAllEditablePropertyData = createSelector(
  [selectEditablePropertyDataEntities],
  (editablePropertyDataEntities) => Object.values(editablePropertyDataEntities),
);
